import React from 'react';
import { getStreamLabel } from '../utils/streamUtils';

/**
 * Placeholder for a missing or unavailable stream slot.
 * Used by PreviewHAChannel and HAChannelGroup.
 */
const StreamSlotPlaceholder = ({ streamLabels, streamId, idx, message }) => (
  <div className="flex-1 min-w-0 flex flex-col bg-gray-900 rounded border border-dashed border-gray-600">
    <div className="flex-shrink-0 px-2 py-1 bg-black bg-opacity-60 text-gray-500 text-xs truncate">
      {getStreamLabel(streamLabels, streamId, idx)}
    </div>
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center text-gray-500 text-sm p-4">{message}</div>
    </div>
  </div>
);

export default StreamSlotPlaceholder;
